// import isMobilePhone from 'validator/lib/isMobilePhone'
import isEmail from 'validator/lib/isEmail'
import {ifStrBlank} from 'Utils/string'

/**
 * 身份证号码验证
 * @param {Number} num 身份证号码
 */
export const isIdCardNo = (num) => {
  var factorArr = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2, 1]
  var parityBit = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2', 'x']
  var varArray = []
  var lngProduct = 0
  var intCheckDigit

  var intStrLen = num.length
  var idNumber = num
  // initialize  (intStrLen != 15) && (
  if (intStrLen !== 18) {
    return false
  }
  // check andset value
  for (let i = 0; i < intStrLen; i++) {
    varArray[i] = idNumber.charAt(i)
    if ((varArray[i] < '0' || varArray[i] > '9') && (i != 17)) {
      return false
    } else if (i < 17) {
      varArray[i] = varArray[i] * factorArr[i]
    }
  }

  if (intStrLen === 18) {
    // check date
    var date8 = idNumber.substring(6, 14)
    if (isDate8(date8) === false) {
      return false
    }
    // calculate the sum of the products
    for (let i = 0; i < 17; i++) {
      lngProduct = lngProduct + varArray[i]
    }
    // calculate the check digit
    intCheckDigit = parityBit[lngProduct % 11]
    // check last digit
    if (varArray[17] !== intCheckDigit) {
      return false
    }
  }
  return true
}
export const isDate8 = (sDate) => {
  if (!/^[0-9]{8}$/.test(sDate)) {
    return false
  }
  var year, month, day
  year = sDate.substring(0, 4)
  month = sDate.substring(4, 6)
  day = sDate.substring(6, 8)
  var iaMonthDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
  if (year < 1700 || year > 2500) return false
  if (((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0)) iaMonthDays[1] = 29
  if (month < 1 || month > 12) return false
  if (day < 1 || day > iaMonthDays[month - 1]) return false
  return true
}

/**
 * 密码复杂度验证
 * 密码字母和数字的组合，不包含特殊字符，6-16长度
 * @param {String} str 字符串
 */
export const passwordComplex = (str) => {
  let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/
  return reg.test(str)
}

// input组件 is-type
export const validators = {
  'is-string': (str, label) => {
    return {
      valid: !ifStrBlank(str),
      msg: `${label}不能为空`
    }
  },
  'mobile': (str) => {
    var reg = /^1[3456789]\d{9}$/
    return {
      valid: !ifStrBlank(str) && reg.test(str),//isMobilePhone(str, 'zh-CN'),
      msg: '请填写正确手机号码格式'
    }
  },
  /**
   * 校验机票下单手机号
   * 开头为0则不校验，否则就按手机号格式校验
   */
  'telephone': (str) => {
    if (str[0] === '0') {
      return {
        valid: true
      }
    }

    return validators.mobile(str)
  },
  'email': (str) => {
    return {
      valid: isEmail(str),
      msg: '请填写正确邮箱格式'
    }
  },
  'password': (str) => {
    return {
      valid: passwordComplex(str),
      msg: '密码由字母和数字的组合，不包含特殊字符，6-16长度'
    }
  },
  'is-idCard': (str) => {
    return {
      valid: isIdCardNo(str),
      msg: '请输入有效身份证信息'
    }
  }
}
